module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img316-c4dba462cd1beef09ef2e5ab39fe1c2e.jpg";